import axios from 'axios';
import Defer from 'promise-defer';
const _baseUrl = 'https://flow.evolvemediallc.com/';
let token = null;

function _authenticate() {
  const def = new Defer();

  axios({
    method: 'POST',
    url: _baseUrl + 'api/v1/auth/getToken',
    params: {
      email: 'c2ktdGVjaC1zd2VlcHNAZXZvbHZlbWVkaWFsbGMuY29t',
      password: 'NTE3M2NoNXczM3A1'
    },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
    }
  }).then(responseAuth => {
    token = responseAuth.data.access_token;
    def.resolve(token);
  }).catch(error => {
    def.reject(error);
  });

  return def.promise;
}

function _vote(def, id, params) {

  axios({
    method: 'POST',
    url: _baseUrl + 'api/v1/poll/' + id,
    params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
      Authorization: 'Bearer ' + token
    }
  }).then(responsePost => {
    def.resolve(responsePost);
  }).catch(error => {
    def.reject(error);
  });
}

function _saveEntry(def, hash, data) {

  axios({
    method: 'POST',
    url: _baseUrl + 'api/v1/sweepstakes/' + hash + '/entries',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: 'Bearer ' + token
    }
  }).then(responsePost => {
    def.resolve(responsePost);
  }).catch(error => {
    def.reject(error);
  });
}

export default class Flow {

  constructor(requestParams) {
    return axios(requestParams);
  }

  static vote(id, params) {
    const def = new Defer();

    _authenticate().then(() => {
      _vote(def, id, params);
    });

    return def.promise;
  }

  static saveEntry(hash, data) {
    const def = new Defer();

    _authenticate().then(() => {
      _saveEntry(def, hash, data);
    });

    return def.promise;
  }

  static results(id) {

    return axios({
      method: 'GET',
      url: _baseUrl + 'api/v1/poll/' + id + '/responses/true'
    });
  }
}
